/**

 * @author Owais

 * @datetime July, 14th 2022

 * @description: This is Error handler class implemented from base class of ErrorHandler.

 */

import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, ErrorHandler } from '@angular/core';
import { checkGenericErrors } from './generic-error-response';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ErrorHandlerService implements ErrorHandler {
  constructor(
    private translateService: TranslateService
  ) {}

  handleError(error: Error) {
    if (!(error instanceof HttpErrorResponse)) {
      if (window.__dev__) console.log('handleError', error);
    } else {
      checkGenericErrors(error.message, this.translateService);
    }
  }
}
